/**
 * Format currency value to USD string
 * @param value - Amount in USD
 * @returns Formatted string like "$1,234.56"
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Format large token numbers with K/M suffix
 * @param value - Token count
 * @returns Formatted string like "1.25M" or "45.0K" or "500"
 */
export const formatTokens = (value: number): string => {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(2)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }
  return value.toString();
};

/**
 * Format number with locale separators
 * @param value - Number to format
 * @returns Formatted string like "1,234"
 */
export const formatNumber = (value: number): string => {
  return value.toLocaleString('en-US');
};
